import React from 'react';

export default function HasPermission({ permission, children }) {
    if (permission) return children;

    return (<></>)
}

